import '../config/polyfills';
import './shared.scss';
import App from './App/App';
import { Provider } from 'react-redux';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { getStore } from './store';
import '@nexio/emvio-form-components/styles.scss';

function ConnectedApp() {
    return (
        <Provider store={getStore()}>
            <App />
        </Provider>
    );
}

createRoot(document.getElementById('root')).render(<ConnectedApp />);
